/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SettingParser = /* #__PURE__ */ parsers.object([
    ['name', codecString],
    ['default', codec.unknown],
    ['value', codec.unknown],
]);
export class Setting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SettingParser.decode(input).map(res => new Setting(res));
    }
    static unsafeDecode(input) {
        return Setting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SettingParser.encode(data);
    }
    static schema() {
        return SettingParser.schema();
    }
}
